/** Real API is the default for every release build. Prototype fixtures are allowed
 * only in local Vite development or an explicitly named QA test build. */
export function isServerMode(): boolean {
  const qaDemo = import.meta.env.MODE === 'test' && import.meta.env.VITE_DEMO_MODE === 'true';
  return !!import.meta.env.VITE_API_BASE || import.meta.env.VITE_MOCK_API === 'true' || (!import.meta.env.DEV && !qaDemo);
}

/** Presentation/debug tools never run against a real API, even in development. */
export function allowsPrototypeTools(): boolean {
  return !isServerMode() && (import.meta.env.DEV || (import.meta.env.MODE === 'test' && import.meta.env.VITE_DEMO_MODE === 'true'));
}
